import Vue from "vue";
import liff from '@line/liff'
import store from '@store'
import openDialog from "./global-dialog";

Vue.prototype.$setGlobal = ({ key, data }) => {
  store.dispatch('global/setGlobal', { key, data })
};

Vue.prototype.$getGlobal = (key) => {
  return store.getters['global/getGlobal'](key)
};

const globalData = new Vue({
  data: {
    $globalDarkTheme: false,
    $globalScrollTop: 0,
    $globalWindowWidth: 0,
    $globalDirection: '',
    $globalBreakpoint: 'sm',
    $globalHambugerOpen: false,
    $globalProjectName: process.env.VUE_APP_MODE,
    $globalPageLoading: false,
    $globalIsDingBeauty: process.env.VUE_APP_MODE === 'dingbeauty',
    $globalIsDingJtails: process.env.VUE_APP_MODE === 'jtails',
  }
});

Vue.mixin({
  computed: {
    $globalDarkTheme: {
      get: function() {
        return store.state.merchant.currentMerchant.alias === 'dannygroomer' || globalData.$data.$globalDarkTheme
      },
      set: function(value) {
        globalData.$data.$globalDarkTheme = value;
      }
    },
    $globalScrollTop: {
      get: function() {
        return globalData.$data.$globalScrollTop
      },
      set: function(value) {
        globalData.$data.$globalScrollTop = value;
      }
    },
    $globalWindowWidth: {
      get: function() {
        return globalData.$data.$globalWindowWidth
      },
      set: function(value) {
        globalData.$data.$globalWindowWidth = value;
      }
    },
    $globalDirection: {
      get: function() {
        return globalData.$data.$globalDirection
      },
      set: function(value) {
        globalData.$data.$globalDirection = value;
      }
    },
    $globalBreakpoint: {
      get: function() {
        return globalData.$data.$globalBreakpoint
      },
      set: function(value) {
        globalData.$data.$globalBreakpoint = value;
      }
    },
    $globalHambugerOpen: {
      get: function() {
        return globalData.$data.$globalHambugerOpen
      },
      set: function(value) {
        globalData.$data.$globalHambugerOpen = value;
      }
    },
    $globalPageLoading: {
      get: function() {
        return globalData.$data.$globalPageLoading
      },
      set: function(value) {
        globalData.$data.$globalPageLoading = value;
      }
    },
    $globalIsMobileDevice: {
      get: function() {
        return /Mobi|Android/i.test(navigator.userAgent)
      }
    },
    $globalIsMobileDevice2: {
      get: function() {
        const mobileDevice = [
         'Android',
         'webOS',
         'iPhone',
         'iPad',
         'iPod',
         'BlackBerry',
         'Windows Phone'
         ];

        return mobileDevice.some(e => navigator.userAgent.match(e));
      }
    },
    $globalIsTouchDevice: {
      get: function() {
        return 'ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
      },
    },
    $globalIsDevelopment: {
      get: function() {
        return process.env.NODE_ENV === 'development'
        // || window.globalData.APP_ENV === 'local'
        // || window.globalData.APP_ENV === 'staging'
      }
    },
    $globalIsOfficial: {
      get: function() {
        return window.globalData.APP_ENV === 'production'
      }
    },
    $globalIsShowRandomScheduleItem: {
      get: function() {
        if(process.env.NODE_ENV === 'development'){
          return store.state.merchant.currentMerchant.cosmeticSetting.showRandomScheduleItem  
        }
        if(window.globalData.APP_ENV === 'production'){
          return window.globalData.merchant.cosmeticSetting.showRandomScheduleItem
        }
        return store.state.merchant.currentMerchant.cosmeticSetting.showRandomScheduleItem
      }
    },
    $globalIsLiffClient: {
      get: function() {
        return !!liff.isInClient()
      }
    },
    $globalProjectName: {
      get: function() {
        return globalData.$data.$globalProjectName
      },
    },
    $globalIsJtailsMode: {
      get: function() {
        return this.$globalProjectName === 'jtails' || this.$globalProjectName === 'dingbeauty'
      },
    },
    $globalIsJtails: {
      get: function() {
        return this.$globalProjectName === 'jtails'
      },
    },
    $globalIsDingBeauty: {
      get: function() {
        return this.$globalProjectName === 'dingbeauty'
      },
    },
    $globalCategoryVisible: {
      get: function() {
        return store.state.merchant.currentMerchant.petCategories.length >= 1 && store.state.merchant.currentMerchant.petCategories[0].children.length >= 1
      },
    }
  },
  methods: {
    $globalDialog(name = '', options = {}) {
      openDialog(name, options)
    }
  }
});
